/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import Invitation from 'entities/Invitation';

class Invitations extends Collection {
  initialize() {
    this.model = Invitation;
  }

  static invite(groupId, recipients) {
    return apiRequest(`/classes/${groupId}/invitations`, 'POST', {
      invitations: recipients.map(recipient => {
        return {
          address: recipient.address,
          name: recipient.name,
        };
      }),
    });
  }
}

export default Invitations;



// WEBPACK FOOTER //
// ./src/collections/Invitations.js